import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=3881d9f6&"
import script from "./Collection.vue?vue&type=script&lang=js&"
export * from "./Collection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ebenhafkamp/Documents/Projects/tacpro/src/webpack/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3881d9f6')) {
      api.createRecord('3881d9f6', component.options)
    } else {
      api.reload('3881d9f6', component.options)
    }
    module.hot.accept("./Collection.vue?vue&type=template&id=3881d9f6&", function () {
      api.rerender('3881d9f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/Collection.vue"
export default component.exports